'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var variables = require('@asphalt-react/tokens');
var helper = require('@asphalt-react/helper');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var variables__default = /*#__PURE__*/_interopDefaultLegacy(variables);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var createHash = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(themeStr) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (themeStr) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            _context.next = 4;
            return helper.hashUtil.hash(themeStr);

          case 4:
            return _context.abrupt("return", _context.sent.substr(0, 8));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createHash(_x) {
    return _ref.apply(this, arguments);
  };
}();

var ThemeProvider = /*#__PURE__*/function (_Component) {
  _inherits(ThemeProvider, _Component);

  var _super = _createSuper(ThemeProvider);

  function ThemeProvider(props) {
    var _this;

    _classCallCheck(this, ThemeProvider);

    _this = _super.call(this, props);
    _this.state = {
      hash: null
    };

    if (props.theme) {
      createHash(JSON.stringify(props.theme)).then(function (hash) {
        _this.setState({
          hash: hash
        }, _this.mountStyles);
      });
    }

    _this.createStyleSheet = _this.createStyleSheet.bind(_assertThisInitialized(_this));
    _this.generateWrapperClass = _this.generateWrapperClass.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ThemeProvider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unMountStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref2) {
      var _this2 = this;

      var theme = _ref2.theme;
      if (!this.props.theme) return;
      var prevThemeStr = JSON.stringify(theme);
      var newThemeStr = JSON.stringify(this.props.theme);
      if (prevThemeStr === newThemeStr) return;
      createHash(newThemeStr).then(function (hash) {
        _this2.setState({
          hash: hash
        }, function () {
          _this2.unMountStyles();

          _this2.mountStyles();
        });
      });
    }
    /**
     * Mounts a <style>
     */

  }, {
    key: "mountStyles",
    value: function mountStyles() {
      var sheet = this.createStyleSheet();
      var selector = ".".concat(this.generateWrapperClass());
      sheet.insertRule(this.createRule(selector, this.props.theme), 0);
    }
  }, {
    key: "generateWrapperClass",
    value: function generateWrapperClass() {
      return "asphalt-theme-".concat(this.state.hash);
    }
    /**
     * Unmounts a previously mounted <style>
     */

  }, {
    key: "unMountStyles",
    value: function unMountStyles() {
      var styleNode = document.querySelector("#asphalt-tokens-".concat(this.state.hash));

      if (styleNode) {
        styleNode.remove();
      }
    }
    /**
     * Create & attach a stylesheet
     */

  }, {
    key: "createStyleSheet",
    value: function createStyleSheet() {
      var styleNode = document.createElement("style");
      styleNode.type = "text/css";
      styleNode.rel = "stylesheet";
      styleNode.id = "asphalt-tokens-".concat(this.state.hash);
      document.head.appendChild(styleNode);
      return styleNode.sheet;
    }
    /**
     * Create CSS rule for token variables
     *
     * @param {String} selector any valid CSS selector
     * @param {Object} variables token variables
     * @returns {String}
     */

  }, {
    key: "createRule",
    value: function createRule(selector, variables) {
      return "".concat(selector, " { ").concat(this.createTokens(variables), " }");
    }
    /**
     * Create CSS String of custom properties
     *
     * @param {Object} variables token variables
     * @returns {String}
     */

  }, {
    key: "createTokens",
    value: function createTokens(variables) {
      return Object.keys(variables).map(function (key) {
        return "".concat(key, ": ").concat(variables[key], ";");
      }).join("");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          children = _this$props.children;
      return theme ? /*#__PURE__*/React__default['default'].createElement("div", {
        className: this.generateWrapperClass()
      }, this.props.children) : children;
    }
  }]);

  return ThemeProvider;
}(React.Component);

ThemeProvider.propTypes = {
  /**
   * React node or node tree to apply theme to
   */
  children: PropTypes__default['default'].node.isRequired,

  /**
   * Asphalt Theme object
   */
  theme: PropTypes__default['default'].object
};
ThemeProvider.defaultProps = {
  theme: variables__default['default']
};

exports.default = ThemeProvider;
